import React, { PropTypes as p } from 'react'

import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

import ServicingServicesUpdateContainer from '../../containers/servicings/servicing-services-update-container'
import AreaActivityContainer from '../../containers/area-activities/area-activity-container'
import PinSelector from '../pins/pin-selector'

const AreaTabs = ({
  id,
  pins,
  area,
  onTabSelect,
  onPinPlace,
  onPinClick,
  selectedTab
}) => (
  <Tabs onSelect={onTabSelect} selectedIndex={selectedTab}>
    <TabList>
      <Tab>Services</Tab>
      <Tab>History/Comments</Tab>
      {area.map.url &&
        <Tab>Map</Tab>
      }
    </TabList>

    <TabPanel>
      <ServicingServicesUpdateContainer servicingId={id} />
    </TabPanel>

    <TabPanel>
      <AreaActivityContainer areaId={area.id} />
    </TabPanel>

    {area.map.url &&
      <TabPanel>
        <PinSelector
          pins={pins}
          onPinPlace={onPinPlace}
          onPinClick={onPinClick}
          mapImageUrl={area.map.url}
        />
      </TabPanel>
    }
  </Tabs>
)

AreaTabs.propTypes = {
  onTabSelect: p.func
}

export default AreaTabs



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-tabs.js